export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-152x152-79ec228805d93ee7bc94232eba7736f2.png";